var path = '/theme/festzelt-os/views/error.html';
var html = "<div class=\"wrapper\" ng-controller=\"ThemeErrorController as error\">\n\n    <div class=\"text-center mt3\">\n            <p><span class=\"pe-7s-attention\" style=\"font-size: 10rem\"></span></p>\n            <p class=\"text\">An error has occured. Try and refresh if issue persist please contact support. </p>\n        <a href=\"#dashboard\" class=\"btn btn-lg btn-primary btn-fill\">Go To Dashboard</a>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/festzelt-os/views/error.html
// module id = 2352
// module chunks = 1